import { Component, computed, inject, signal } from '@angular/core';
import { AutocompleteCustomerComponent } from '../../components/autocomplete/wrappers/autocomplete-customer.component';
import { ExtendedAuthService } from '../auth.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { GhostingService } from './ghosting.service';
import { isSystemAdministrator } from '../role.guard';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AuthUser } from '../auth.interfaces';
import { AdminRole } from '../../../api/staff/lib/staff.interfaces';
import { filter } from 'rxjs';

@Component({
  selector: 'app-ghosting',
  standalone: true,
  imports: [AutocompleteCustomerComponent, ReactiveFormsModule],
  templateUrl: './ghosting.component.html',
  styleUrl: './ghosting.component.scss',
})
export class GhostingComponent {
  authService = inject(ExtendedAuthService);
  ghostingService = inject(GhostingService);
  user = toSignal(this.authService.user$, { initialValue: null });
  asUser = toSignal(this.ghostingService.asUser$, { initialValue: null });

  canGhost = computed(() => {
    const user = this.user();
    return (
      isSystemAdministrator(user) ||
      !!user?.adminRoles?.includes(AdminRole.Office)
    );
  });
  ghostedName = computed(() => {
    const asUser = this.asUser();
    if (asUser) return `${asUser.firstName} ${asUser.lastName}`;
    return asUser;
  });
  ghostInProgress = toSignal(this.ghostingService.inProgress$);
  ghostControl = new FormControl<AuthUser | null>(null);
  wantsToGhost = signal(false);

  constructor() {
    this.ghostControl.valueChanges
      .pipe(filter((user): user is AuthUser => !!user))
      .subscribe((user) => this.ghostingService.setAsUser(user));
  }

  stop() {
    this.ghostingService.clearAsUser();
  }
}
